module.exports = __webpack_public_path__ + "media/images/flags/64/Lebanon-6e519453cfd495c6524cdb5e6deac99a.png";